import * as types from './mutation_types';

let mutations = {
    [types.SET_ALERT_SHOW](state){
        state.alert.isShow = true;
    },
    [types.SET_ALERT_HIDE](state){
        state.alert.isShow = false;
    },
    [types.SET_ALERT_DATA](state, data){
        state.alert.data = data;
    },


    [types.SET_CONFIRM_SHOW](state){
        state.confirm.isShow = true;
    },
    [types.SET_CONFIRM_HIDE](state){
        state.confirm.isShow = false;
    },
    [types.SET_CONFIRM_DATA](state, data){
        state.confirm.data = data;
    },


    [types.SET_TITLE_CONFIRM_SHOW](state){
        state.titleConfirm.isShow = true;
    },
    [types.SET_TITLE_CONFIRM_HIDE](state){
        state.titleConfirm.isShow = false;
    },
    [types.SET_TITLE_CONFIRM_DATA](state, data){
        state.titleConfirm.data = data;
    },

    [types.SET_HIDE_REGISTER_TIP](state){
        state.isShowRegisterTip = false;
    },
    [types.SET_SHOW_REGISTER_TIP](state){
        state.isShowRegisterTip = true;
    },

    [types.SET_MIXINTRANSFER_UPK](state, upk){
        state.mixinTransfer_upk = upk;
    },

    [types.SET_BAIDU_BINDTOKENSIGN](state, bindTokenSign){
        state.baidu_bindTokenSign = bindTokenSign;
    }
};


export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js